import React, { useState } from "react";
import PropTypes from "prop-types";

import { Box, Button, TextField, makeStyles } from "@material-ui/core";
import { navigate } from "gatsby";
import { v4 } from "uuid";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: `${theme.palette.primary.main} !important`,
      color: "white",
    },
    color: "white",
  },
  darkInput: {
    color: "white !important",
    "&$cssFocused": {
      color: "white !important",
    },
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "white !important",
  },
  cssFocused: {},
  containerCenter: {
    display: "block",
    marginRight: "auto",
    marginLeft: "auto",
    marginBottom: "50px",
    marginTop: "50px",
  },
  containerLeft: {
    marginBottom: "50px",
    marginTop: "50px",
  },
}));

const StartTrialForm = ({ align = "center", dark = false }) => {
  const classes = useStyles();
  const [email, setEmail] = useState("");

  const handleEmailChange = React.useCallback((e) => {
    setEmail(e.target.value);
  }, []);

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const recordId = v4();
    const data = {
      email,
      recordId,
    };

    axios.put(
      `https://lablog-62234.firebaseio.com/request-trial/${recordId}.json`,
      { data }
    );

    navigate("/get-started/create", {
      state: { data },
    });
  };

  return (
    <Box
      component="div"
      maxWidth="450px"
      alignContent={align}
      className={
        align === "center" ? classes.containerCenter : classes.containerLeft
      }
    >
      <form onSubmit={handleFormSubmit} method="post">
        <Button
          variant="contained"
          type="submit"
          disableElevation
          style={{
            fontSize: "large",
            float: "right",
            height: "55px",
            marginTop: "7px",
            backgroundColor: `${dark ? "white" : "black"}`,
            color: `${!dark ? "white" : "black"}`,
          }}
        >
          Try LabLog
        </Button>
        <div
          style={{
            overflow: "hidden",
            paddingRight: "10px",
            height: "100px",
            paddingTop: "8px",
          }}
        >
          {dark && (
            <TextField
              fullWidth
              onChange={handleEmailChange}
              required
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.darkInput,
                  focused: classes.darkInput,
                },
              }}
              variant="outlined"
              label="Work email address"
              type="email"
            />
          )}
          {!dark && (
            <TextField
              fullWidth
              onChange={handleEmailChange}
              required
              variant="outlined"
              label="Work email address"
              type="email"
            />
          )}
        </div>
      </form>
    </Box>
  );
};

StartTrialForm.propTypes = {
  align: PropTypes.string,
  dark: PropTypes.bool,
};

export default StartTrialForm;
